// @flow
import WebComponent from '../src/webComponents/WebComponent';
import * as CursorSpinner from '../src/components/CursorSpinner';
import $ from 'jquery';
import {eshopUserToolsRefresh} from '../webActions/eshopUserToolsRefresh';

export default class EshopOrderForm extends WebComponent {
	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	didMount() {
		this.on('submit', this.handleSubmit);
	}

	/**
	 * partial update after item has been put into shopping cart
	 */
	handleSubmit(e) {
		e.preventDefault();
		CursorSpinner.pushToQueue('addItemToBasket');
		let postUrl = this.element.getAttribute('action');
		if (postUrl.indexOf('?') === -1) {
			postUrl += '@pageContainer';
		} else {
			postUrl = postUrl.replace('?', '@pageContainer?');
		}

		$.post(postUrl, $(this.element).serialize(), (data) => {
			CursorSpinner.removeFromQueue('addItemToBasket');
			edeeshopPopup.createPopup(data, 'esp-add-to-cart');
			document.querySelector('.esp-add-to-cart .btn-next').focus();
			eshopUserToolsRefresh();
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/EshopOrderForm.js